import { TLCRest } from "./rest/REST";
import { TLCEXT } from "./ext/Ext";

export const TemplateEngine = (function ($, global) {
	var
		templatesCache = {},
		methodString = {
			append: "append",
			overwrite: "overwrite",
			prepend: "prepend"
		},
		requestTemplate = function (templatePath, callback) {

			var tempCacheKey = templatePath.replace(/\//g, "_");
			tempCacheKey = tempCacheKey.replace(/\./g, "_");
			if (templatesCache[tempCacheKey] === undefined) {
				TLCRest.fetchHTML(templatePath + ((global.svnRevision) ? "?v=" + global.svnRevision : ""), function (tmpl) {
					var ext = TLCEXT.Template(tmpl);
					templatesCache[tempCacheKey] = {
						tmpl: tmpl,
						ext: ext
					};
					callback(templatesCache[tempCacheKey], true);
				});
			}
			else {
				callback(templatesCache[tempCacheKey], false);
			}
		};
	var extendData = function (passedBaseValues, data) {
		if (passedBaseValues !== undefined && data !== undefined) {
			if (data.constructor.toString().indexOf("Array") != -1) {
				var temp = [];
				for (var i = 0, len = data.length; i < len; i++) {
					temp.push($.extend(true, {}, passedBaseValues, data[i]));
				}
				return temp;
			}
			else {
				return $.extend(true, {}, passedBaseValues, data);
			}
		}
		else {
			return data;
		}
	};
	return {
		/**
		 *
		 * @param {string=} templatePath
		 * @param {*=} data
		 * @param {Function=} callback
		 * @param {*=} passedBaseValues
		 * @deprecated
		 */
		compile: function (templatePath, data, callback, passedBaseValues) {
			requestTemplate(templatePath, function (tmplObj, cameFromServer) {
				if (callback) {
					callback(tmplObj.ext.populate(extendData(passedBaseValues, data)), tmplObj, cameFromServer);
				}
			});
		},
		/**
		 *
		 * @param {string} templatePath
		 * @param {string|jQuery} idOrElement
		 * @param {*=} data
		 * @param {Function=} callback
		 * @param {string=} method
		 * @param {*=} passedBaseValues
		 * @deprecated
		 */
		fetch: function (templatePath, idOrElement, data, callback, method, passedBaseValues) {
			method = method || methodString.append;
			requestTemplate(templatePath, function (tmplObj, cameFromServer) {
				tmplObj.ext[method](idOrElement, extendData(passedBaseValues, data));
				if (callback) {
					callback(tmplObj.ext, cameFromServer);
				}
			});
		},
		/**
		 * @deprecated
		 */
		method: methodString,

		/**
		 * @deprecated
		 */
		clearCache: function () {
			templatesCache = {}
		}
	};
})(jQuery, window);